<template>
    <div class="modal fade" id="appMgrAccessAuthorityModal" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv" style="width:960px">
                <div class="modal-header modal-header-scv-cmn">
                    <div class="modal-header-text-box-scv">
                        <div class="modal-header-text-scv">
                            アクセス権限の許可設定
                        </div>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <template v-if="show">
                        <div class="main-setting-table">
                            <div class="main-category-text">
                                <span class="main-category-font">既定の設定</span>
                            </div>
                        </div>
                        <div style="margin: 16px;">
                            アプリケーションが要求するアクセス権限の許可について、既定となる設定を行ってください。
                            <div class="d-flex flex-row" style="margin-left: 16px; margin-top: 12px;">
                                <label class="scv-check-label-box">
                                    <input type="radio" name="defaultAppMgrAccessAuthorityModal" v-model="defaultPermissionSetting" v-bind:value="Prompt">
                                    <span>{{converter.GetPermissionSettingText(Prompt)}}</span>
                                </label>
                                <label class="scv-check-label-box" style="margin-left: 24px;">
                                    <input type="radio" name="defaultAppMgrAccessAuthorityModal" v-model="defaultPermissionSetting" v-bind:value="Grant">
                                    <span>{{converter.GetPermissionSettingText(Grant)}}</span>
                                </label>
                                <label class="scv-check-label-box" style="margin-left: 24px;">
                                    <input type="radio" name="defaultAppMgrAccessAuthorityModal" v-model="defaultPermissionSetting" v-bind:value="Deny">
                                    <span>{{converter.GetPermissionSettingText(Deny)}}</span>
                                </label>
                            </div>
                        </div>

                        <div class="main-setting-table">
                            <div class="main-category-text">
                                <span class="main-category-font">アクセス権限ごとの個別設定</span>
                            </div>
                        </div>
                        <div style="margin: 16px;">
                            既定の設定から変更するアクセス権限がある場合は、チェックを入れて個別に設定を行ってください。
                        </div>
                        <div class="overflow-auto" style="height: 600px; border: 0.5px solid #E6EBF0;">
                            <template v-if="0 == list.length">
                                <div class="d-flex align-items-center justify-content-center attention scv-annotation-text" style="height: 100%;">
                                    このアプリケーションには設定できるアクセス権限がありません。
                                </div>
                            </template>
                            <div style=" margin: 0px 16px;">
                                <template v-for="(item, index) in list" v-bind:key="index">
                                    <template v-if="null != item.permissionId && undefined != item.permissionId">
                                        <div class="d-flex flex-column" style="margin-left: 16px; margin-top: 24px; margin-right: 16px; min-width: 800px;">
                                            <div class="setting-title-text d-flex flex-row">
                                                <label class="scv-check-label-box">
                                                    <input type="checkbox" v-model="listEnabled[item.permissionId]">
                                                    <span>{{converter.GetPermissionNameText(item)}}</span>
                                                </label>
                                            </div>
                                            <div class="setting-description-text" style="margin-top: 24px; margin-right: 16px;">
                                                <template v-if="null != item.description">
                                                    {{item.description}}
                                                </template>
                                            </div>
                                            <template v-if="listEnabled[item.permissionId]">
                                                <div class="d-flex flex-wrap  justify-content-end" style="column-gap: 8px; row-gap: 8px; margin-right:16px; margin-top: 16px">
                                                    <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                                                        <label class="btn btn-scv-select-blue" v-bind:class="{ active: settings[item.permissionId] == Prompt }" :name="index.toString()" style="width: 144px">
                                                            <input class="btn-check" type="radio" :name="index.toString()" v-model="settings[item.permissionId]" :value="Prompt">
                                                            <span>{{converter.GetPermissionSettingText(Prompt)}}</span>
                                                        </label>
                                                    </div>
                                                    <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                                                        <label class="btn btn-scv-select-blue" v-bind:class="{ active: settings[item.permissionId] == Grant }" :name="index.toString()" style="width: 144px">
                                                            <input class="btn-check" type="radio" :name="index.toString()" v-model="settings[item.permissionId]" :value="Grant">
                                                            <span>{{converter.GetPermissionSettingText(Grant)}}</span>
                                                        </label>
                                                    </div>
                                                    <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                                                        <label class="btn btn-scv-select-blue" v-bind:class="{ active: settings[item.permissionId] == Deny }" :name="index.toString()" style="width: 144px">
                                                            <input class="btn-check" type="radio" :name="index.toString()" v-model="settings[item.permissionId]" :value="Deny">
                                                            <span>{{converter.GetPermissionSettingText(Deny)}}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="scv-separator-bg" style="margin-top: 24px;"></div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <div style="margin-top: 8px;">
                            <button type="button" class="btn-scv-lightblue-small" @click="onInit" v-bind:disabled="!IsEnableInitButton()">すべてのチェックを外す</button>
                        </div>
                    </template>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-blue" @click="onOK">OK</button>
                            <button type="button" class="btn-scv-white" data-bs-dismiss="modal" style="margin-left: 40px;">キャンセル</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { cloneDeep } from 'lodash';
    import $ from "jquery";
    import { ApplicationPolicyDef, ApplicationPolicyConverter } from '@/models/Mobile/AndroidAppDist/ApplicationPolicyConverter'
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
    import { BootstrapUtil } from 'lib-vue-v2/util';    

    @Options({
        props: {
            prefixID: { type: Number, required: true },  // このモーダル画面のIDのプレフィックス

            /* list と listSettingは長さは一致しなくてもいい */
            list: { type: Array, required: true },  // 権限一覧（Array<schema.AMAPI_ApplicationPermission>）
            listSetting: { type: Array, required: true },  // 設定一覧（Array<schema.AMAPI_PermissionGrant>）

            defaultPermission: { type: String, required: true }, // 既定の権限設定(ApplicationPolicyDef.PERMISSION_GRANT_TYPE)
        },
        components: {
        },
        computed: {
        },
        emits: [
            /*
             * OKボタン押下
             * @param[in] Array<schema.AMAPI_PermissionGrant> : 設定内容(cloneDeep済み)
             * @param[in] ApplicationPolicyDef.PERMISSION_GRANT_TYPE : 既定の設定(cloneDeep済み)
             */
            'onOK'
        ],
    })

    export default class AppMgrAccessAuthorityModal extends Vue {
        // props
        private prefixID!: number;        // 自身のID
        private list!: Array<schema.AMAPI_ApplicationPermission>;        // 権限情報一覧
        private listSetting!: Array<schema.AMAPI_PermissionGrant>;       // 設定一覧(有効なデータ)
        private defaultPermission!: string;  // 初期設定

        // メンバ変数
        private settings: { [key: string]: ApplicationPolicyDef.PERMISSION_GRANT_TYPE } = {};
        private listEnabled: { [key: string]: boolean } = {};   // 有効/無効
        private defaultPermissionSetting: ApplicationPolicyDef.PERMISSION_GRANT_TYPE = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Prompt;

        // 定数(グローバル変数はなぜかHTMLにbindできない)
        private readonly Prompt = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Prompt;
        private readonly Grant = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Grant;
        private readonly Deny = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Deny;

        // ポリシー⇔UIデータ
        private converter = new ApplicationPolicyConverter();

        // 表示中かどうか(開いたタイミングで描画が走るようにv-ifで表示/非表示を管理する)
        private show = false;

        /**
         * @brief	mounted
         * @note    インスタンスが DOM 要素にマウントされた後
         * @return	なし
         */
        public mounted(): void {
            $('#appMgrAccessAuthorityModal').attr('id', "appMgrAccessAuthorityModal" + this.prefixID);

            const el = document.getElementById("appMgrAccessAuthorityModal" + this.prefixID);
            if(null != el) {
                // 画面が開いた時の処理
                el.addEventListener('show.bs.modal', () => {

                    this.settings = this.converter.CreatePermissionSetting(this.list, this.listSetting);
                    this.defaultPermissionSetting = this.converter.ConvertStringToPermissionType(this.defaultPermission);

                    let setEnableKey = new Set<string>();
                    this.listSetting.forEach(x => {
                        if (null == x.permission || undefined == x.permission) {
                            // keyがないアクセス権限は想定外
                            return;
                        }
                        setEnableKey.add(x.permission)
                    });

                    this.list.forEach(x => {
                        if (null == x.permissionId || undefined == x.permissionId) {
                            // keyがないアクセス権限は想定外
                            return;
                        }

                        // 設定になければ無効
                        if (setEnableKey.has(x.permissionId)) {
                            this.listEnabled[x.permissionId] = true;
                        }
                        else {
                            this.listEnabled[x.permissionId] = false;
                        }
                    });

                    this.show = true;
                });

                // 画面が閉じた時の処理
                el.addEventListener('hidden.bs.modal', () => {

                    this.settings = {};
                    this.defaultPermissionSetting = ApplicationPolicyDef.PERMISSION_GRANT_TYPE.Prompt;
                    this.show = false;
                });
            }
        }

        /**
         * @brief	OKボタン
         */
        private onOK(): void {
            const changedData: Array<schema.AMAPI_PermissionGrant> = new Array<schema.AMAPI_PermissionGrant>();

            // 有効の設定だけ送信する
            for (const key in this.listEnabled) {
                if (this.listEnabled[key]) {
                    const item = new schema.AMAPI_PermissionGrant();
                    item.permission = key;
                    item.policy = this.settings[key];
                    changedData.push(item);
                }
            }

            this.$emit('onOK', cloneDeep(changedData), cloneDeep(this.defaultPermissionSetting));
            BootstrapUtil.hideModal("appMgrAccessAuthorityModal" + this.prefixID);
        }

        /**
        * @brief	すべてのチェックを外すボタン押下
        */
        private onInit(): void {
            for (const key in this.listEnabled) {
                this.listEnabled[key] = false;
            }

            this.settings = this.converter.CreatePermissionSetting(this.list, undefined);
        }

        /**
         * @brief	すべてのチェックを外すボタンが有効かどうか
         */
        private IsEnableInitButton(): boolean {
            // リストが0なら無効
            if (0 == this.list.length) {
                return false;
            }

            // 一つでも有効なら有効
            for (const key in this.listEnabled) {
                if (this.listEnabled[key]) {
                    return true;
                }
            }

            return false;
        }
    }
</script>

<style scoped>
    /* テキストタイトル(右寄せ) */
    .box-item-title-right {
        display: flex;
        justify-content: end;
        align-items: center;
        height: 32px;
        width: 7em;
        margin-left: 24px;
    }

    /* 設定項目 */
    .title-box {
        display: flex;
        align-items: center;
        flex-direction: row;
    }

    /* 設定タイトル */
    .setting-title-text {
        font-size: 17px;
        font-weight: bold;
        word-wrap: break-word; /* はみ出る分は改行 */
    }

    /* 設定 説明 */
    .setting-description-text {
        font-size: 14px;
        opacity: 0.8;
        word-wrap: break-word; /* はみ出る分は改行 */
    }
</style>
